import { render, staticRenderFns } from "./InputDropdownMultiselect.component.vue?vue&type=template&id=1048252e"
import script from "./InputDropdownMultiselect.component.vue?vue&type=script&lang=js"
export * from "./InputDropdownMultiselect.component.vue?vue&type=script&lang=js"
import style0 from "./InputDropdownMultiselect.component.vue?vue&type=style&index=0&id=1048252e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports